export async function runWithConcurrencyLimit<T, R>(
    items: T[],
    limit: number,
    taskRunner: (item: T, index: number) => Promise<R>,
    onProgress?: (completed: number, total: number, result?: R) => void,
): Promise<PromiseSettledResult<R>[]> {
    const safeLimit = Math.max(1, limit || 5);
    const results: PromiseSettledResult<R>[] = new Array(items.length);
    let currentIndex = 0;
    let completedCount = 0;

    const workers = Array.from({ length: Math.min(safeLimit, items.length) }, async () => {
        while (currentIndex < items.length) {
            const index = currentIndex++;
            const item = items[index];
            try {
                const val = await taskRunner(item, index);
                results[index] = { status: 'fulfilled', value: val };
                completedCount++;
                onProgress?.(completedCount, items.length, val);
            } catch (err) {
                results[index] = { status: 'rejected', reason: err };
                completedCount++;
                onProgress?.(completedCount, items.length);
            }
        }
    });

    await Promise.all(workers);
    return results;
}
